export const SEO_HOME_ES = {
  title: "Lucentia Social | Instagram, web y reservas para negocios con cita",
  description:
    "Gestión de Instagram, página web y reservas online para negocios con cita en España. Planes desde 249 €/mes y auditoría estratégica gratuita con Jenifer Roelstraete.",
  path: "/",
  keywords:
    "más reservas, sistema de reservas, automatización negocios, estrategia digital, Instagram reservas, web design, Jenifer Roelstraete, Lucentia Social, lucentiasocial.com, España, Argentina",
  ogImage: "/og-image.jpg",
  ogImageWidth: 1200,
  ogImageHeight: 630,
  ogImageAlt: "Lucentia Social — estrategia digital y automatización para más reservas",
  breadcrumbHome: "Inicio",
} as const;

export const SEO_METHOD_ES = {
  title: "El Sistema Lucentia® — Más reservas sin herramientas aisladas | Lucentia Social",
  description:
    "Conocé el Sistema Lucentia®: Instagram, web, reservas y automatización trabajando juntos para atraer clientes y hacer crecer tu negocio.",
  path: "/metodo",
  keywords:
    "Sistema Lucentia, sistema de reservas, estrategia digital, automatización negocios, más reservas, Lucentia Social",
  ogImage: "/og-image.jpg",
  ogImageWidth: 1200,
  ogImageHeight: 630,
  ogImageAlt: "El Sistema Lucentia® — un sistema para conseguir más reservas",
  breadcrumbMethod: "Sistema Lucentia",
} as const;

export const SEO_INSTAGRAM_ADVISORY_ES = {
  title:
    "Asesoría Estratégica de Instagram — Estrategia personalizada | Lucentia Social",
  description:
    "Aprendé a gestionar el Instagram de tu negocio con una asesoría 100% personalizada en video, Kit de Implementación Lucentia y 7 días de soporte por WhatsApp.",
  path: "/asesoria-instagram",
  keywords:
    "asesoría Instagram, estrategia Instagram negocios, kit implementación Lucentia, community manager DIY, Lucentia Social",
  ogImage: "/og-image.jpg",
  ogImageWidth: 1200,
  ogImageHeight: 630,
  ogImageAlt: "Asesoría Estratégica de Instagram — Lucentia Social",
  breadcrumb: "Asesoría Estratégica de Instagram",
} as const;

export const SEO_INSTAGRAM_MANAGEMENT_ES = {
  title:
    "Gestión Estratégica de Instagram — Más reservas | Lucentia Social",
  description:
    "Gestión completa de Instagram para negocios con reservas: estrategia, contenido, diseño, comunidad y optimización continua para llenar tu agenda.",
  path: "/gestion-instagram",
  keywords:
    "gestión estratégica Instagram, community management reservas, Instagram para negocios, contenido Instagram, Lucentia Social",
  ogImage: "/og-image.jpg",
  ogImageWidth: 1200,
  ogImageHeight: 630,
  ogImageAlt: "Gestión Estratégica de Instagram — Lucentia Social",
  breadcrumb: "Gestión Estratégica de Instagram",
} as const;

export const SEO_WEB_SERVICE_ES = {
  title: "Página Web Estratégica — Convierte visitas en reservas | Lucentia Social",
  description:
    "Diseño web personalizado con reservas online, SEO, AEO, GEO, WhatsApp e IA. Páginas web pensadas para negocios con reservas que quieren convertir más.",
  path: "/pagina-web",
  keywords:
    "página web estratégica, diseño web reservas, web para peluquerías, SEO AEO GEO, reservas online, Lucentia Social",
  ogImage: "/og-image.jpg",
  ogImageWidth: 1200,
  ogImageHeight: 630,
  ogImageAlt: "Página Web Estratégica — Lucentia Social",
  breadcrumbWeb: "Página Web Estratégica",
} as const;

export const SEO_RESOURCES_ES = {
  title: "Recursos gratis para impulsar tu negocio | Lucentia Social",
  description:
    "Guías gratuitas de Lucentia Social: Optimización de Perfil de Instagram y el Mapa del Sistema Lucentia para conectar Instagram, web y reservas.",
  path: "/recursos",
  keywords:
    "recursos gratuitos, guía Instagram gratis, optimizar perfil Instagram, bio que vende, reservas online, Lucentia Social, lucentiasocial.com, España, Argentina",
  ogImage: "/og-image.jpg",
  ogImageWidth: 1200,
  ogImageHeight: 630,
  breadcrumbResources: "Recursos",
  itemListName: "Recursos gratuitos de Lucentia Social",
} as const;

export const SEO_PRICING_ES = {
  title: "Precios de gestión de Instagram y community manager | Lucentia Social",
  description:
    "Planes de gestión de Instagram desde 249 €/mes, Pack Bienvenida de 130 € y tarifas de reels, posts y carruseles. Precios claros y qué incluye cada plan.",
  path: "/precios",
  keywords:
    "precio community manager, cuánto cuesta un community manager, gestión de Instagram precio, packs redes sociales, tarifas reels, Lucentia Social",
  ogImage: "/og-image.jpg",
  ogImageWidth: 1200,
  ogImageHeight: 630,
  ogImageAlt: "Precios y planes de Lucentia Social",
  breadcrumb: "Precios",
} as const;

export const SEO_NOT_FOUND_ES = {
  title: "Página no encontrada | Lucentia Social",
  description: "La página que buscás no existe o cambió de dirección.",
} as const;

export const SEO_LEGAL_ES = {
  keywords:
    "aviso legal, política de privacidad, cookies, RGPD, LOPDGDD, Lucentia Social, lucentiasocial.com",
} as const;

export const SEO_ANALYTICS = {
  title: "Lucentia Admin",
  description: "Panel privado de administración de Lucentia Social.",
  path: "/admin",
  robots: "noindex, nofollow",
} as const;

export const SEO_PERSON_JOB_TITLE_ES = "Estratega digital & especialista en reservas";
export const SEO_SERVICE_NAME_ES = "Lucentia Social — Estrategia digital y sistemas de reservas";
export const SEO_SERVICE_TYPES_ES = [
  "Gestión Estratégica de Instagram",
  "Asesoría Estratégica de Instagram",
  "Página Web Estratégica",
  "Sistemas de reservas",
  "Automatización de negocios",
] as const;
export const SEO_AREA_SERVED_ES = [
  { "@type": "Country", name: "España" },
  { "@type": "Country", name: "Argentina" },
] as const;

export const SEO_BLOG_ES = {
  title: "Blog para negocios con cita: Instagram, web y reservas | Lucentia Social",
  description:
    "Guías prácticas de Instagram, página web, reservas online y automatización para peluquerías, centros de estética y negocios con cita. Escritas por Jenifer Roelstraete.",
  path: "/blog",
  keywords:
    "blog marketing negocios con cita, Instagram para peluquerías, Instagram para centros de estética, reservas online, SEO local, automatización, Lucentia Social",
  ogImageAlt: "Blog de Lucentia Social — ideas para llenar tu agenda",
  breadcrumb: "Blog",
  name: "Blog de Lucentia Social",
} as const;
